import React from 'react';
import { HelpCircle, Type, BarChart2, MousePointer, FileText, Book } from 'lucide-react';

/**
 * Компонент боковой панели с советами по типографике
 */
const TypographyTipsSidebar = () => {
  // Массив советов по типографике
  const tips = [
    {
      icon: Type,
      title: 'Размер шрифта',
      description: 'Для основного текста на экране используйте не менее 16px. В печати - не менее 10pt.'
    },
    {
      icon: Book,
      title: 'Гарнитура',
      description: 'Для чтения с экрана лучше использовать шрифты без засечек (sans-serif). Для печати подойдут шрифты с засечками (serif).'
    },
    {
      icon: BarChart2,
      title: 'Контрастность',
      description: 'Соотношение контрастности между текстом и фоном должно быть не менее 4.5:1 согласно WCAG AA.'
    },
    {
      icon: MousePointer,
      title: 'Плотность текста',
      description: 'Оптимальная длина строки - 60-80 символов. Слишком длинные строки затрудняют чтение.'
    },
    {
      icon: FileText,
      title: 'Интерлиньяж',
      description: 'Высота строки (line-height) должна быть 1.5-1.6 для основного текста. Это улучшает удобочитаемость.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по типографике
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <FileText className="w-5 h-5 text-purple-500 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-purple-700 dark:text-purple-300 mb-2">
              Российские стандарты типографики
            </h4>
            <p className="text-xs text-purple-600 dark:text-purple-400 mb-3">
              В России действуют строгие стандарты оформления текста для государственных сайтов и документов.
            </p>
            <ul className="text-xs text-purple-600 dark:text-purple-400 space-y-1.5 list-disc list-inside">
              <li>ГОСТ Р 58511-2019 - требования к шрифтовому оформлению</li>
              <li>ГОСТ Р 57850-2017 - оформление сайтов для слабовидящих</li>
              <li>СанПиН 1.2.3685-21 - гигиенические нормативы для электронных изданий</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypographyTipsSidebar;